class OmetriaFormValidation extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['error', 'success']
  }

  connectedCallback () {
    super.connectedCallback()
    this.toggleErrorMessage()
  }

  toggleErrorMessage () {
    const formSubmissionOk =
      new URLSearchParams(window.location.search).get('ometria_form_ok') === 'Y'
    const formErrors = new URLSearchParams(window.location.search).get(
      'ometria_form_errors',
    )
      ? JSON.parse(
        new URLSearchParams(window.location.search).get('ometria_form_errors'),
      )
      : null

    const errorMessage = formErrors
      ? formErrors.reduce((error, [field, message]) => {
        if (!error[field]) {
          error[field] = message
        }
        return error
      }, {})
      : null

    if (formSubmissionOk) {
      this.els.success.element.removeAttribute('aria-hidden')
    } else if (errorMessage) {
      this.els.error.element.innerHTML =
        errorMessage[Object.keys(errorMessage)[0]]
      this.els.error.element.removeAttribute('aria-hidden')
    }
  }
}

if (!customElements.get('ometria-form-validation')) {
  customElements.define('ometria-form-validation', OmetriaFormValidation)
}
